import type { NavGroup, NavItem } from "@/types/navigation"

export const mainNav: NavItem[] = [
  {
    title: "Рецепти",
    href: "/recipes",
    description:
      "Каталог домашніх заготовок: мариновані овочі, ферментація, варення та компоти.",
  },
  {
    title: "Добірки",
    href: "/collections",
    description:
      "Тематичні та сезонні підбірки рецептів для швидкого вибору під конкретний сценарій.",
  },
  {
    title: "Сезонні хаби",
    href: "/seasonal",
    description:
      "Що готувати саме зараз: сезонні рецепти, поради та корисні інструменти.",
  },
  {
    title: "Підібрати за інгредієнтами",
    href: "/ingredient-finder",
    description:
      "Вкажіть продукти, які є вдома, і швидко знайдіть рецепти, що підходять.",
  },
  {
    title: "Калькулятори",
    href: "/calculators",
    description:
      "Розрахунок маринаду, солі, цукру та інші корисні інструменти для консервації.",
  },
  {
    title: "Блог",
    href: "/blog",
    description:
      "Пояснення, сезонні сценарії, практичні статті та корисний контент для домашніх заготовок.",
  },
  {
    title: "Гайди",
    href: "/guides",
    description:
      "Пояснення процесів, помилки консервації, стерилізація та поради з безпеки.",
  },
  {
    title: "Календар",
    href: "/calendar",
    description:
      "Сезонний ритм заготовок, домашнє планування та корисні орієнтири.",
  },
  {
    title: "Спільнота",
    href: "/community",
    description:
      "Користувацькі рецепти, обговорення та досвід домашніх кулінарів.",
  },
  {
    title: "Товари",
    href: "/products",
    description:
      "Банки, кришки, інструменти та корисні речі для домашніх заготовок.",
  },
]

export const footerNav: NavGroup[] = [
  {
    title: "Портал",
    items: [
      { title: "Головна", href: "/" },
      { title: "Рецепти", href: "/recipes" },
      { title: "Добірки рецептів", href: "/collections" },
      { title: "Сезонні хаби", href: "/seasonal" },
      { title: "Підібрати за інгредієнтами", href: "/ingredient-finder" },
      { title: "Калькулятори", href: "/calculators" },
      { title: "Календар заготовок", href: "/calendar" },
    ],
  },
  {
    title: "Контент і поради",
    items: [
      { title: "Блог", href: "/blog" },
      { title: "Гайди", href: "/guides" },
      { title: "FAQ", href: "/faq" },
      { title: "Товари", href: "/products" },
    ],
  },
  {
    title: "Спільнота",
    items: [
      { title: "Спільнота", href: "/community" },
      { title: "Поділитися рецептом", href: "/submit-recipe" },
      { title: "Про проєкт", href: "/about" },
      { title: "Контакти", href: "/contact" },
    ],
  },
  {
    title: "Документи",
    items: [
      { title: "Політика конфіденційності", href: "/privacy-policy" },
      { title: "Умови використання", href: "/terms-of-use" },
    ],
  },
]